import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import {
	getAccountDetails,
	getMyMemberships,
} from '../../../../../Redux/Actions/EndUser/AccountDetailsActions';
import {
	GetRegionAndDistrictSupervisor
} from '../../../../../Redux/Actions/CommonActions'
import SubscriptionDetails from '../SubscriptionDetails/SubscriptionDetails';
import { auth } from '../../../../../services';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import { provideIntlService } from '@progress/kendo-react-intl';
//import { Button } from 'react-bootstrap/Button'

class SpecialRanger extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		};

	}

	componentDidMount() {
		var userId = auth.getAuthUserId();
		this.props.getMyMemberships(userId);
		console.log(this.props, 'these my props on load')
		this.props.GetRegionAndDistrictSupervisor(this.props.accountDetails.selectedMember.membershipId);
	}

	findYourRanger() {
		window.open("https://tscra.org/what-we-do/theft-and-law/find-your-ranger/", "_blank");
	}

	render() {
		
		if (this.props.getting)
			return (
				<div>
					<IsLoading />
				</div>
			);
		return (
			<div className="account-tab-content">
					<div>
						<div>
							<h1 className="pt-3 pb-3">Region Supervisor</h1>
						</div>
						{
							this.props.supervisors ? 
								<div className="card">
									<div className="singleRow borderItems">
										<div className="textStylingRegionDistrict">
											<div className="padItem">Region:</div>
											<label className="infoRangerText">{this.props.supervisors.regionName }</label> 
										</div>
									</div>
									<div className="singleRow borderItems">
										<div className="textStylingRegionDistrict">
											<div className="padItem">Supervisor Name: </div>
											<label className="infoRangerText">{this.props.supervisors.supervisorFirstName + " " + this.props.supervisors.supervisorLastName }</label>
										</div>
									</div>
									<div className="singleRow borderItems">
										<div className="textStylingRegionDistrict">
											<div className="padItem">Address: </div>
											<label className="infoRangerText">{this.props.supervisors.supervisorAddress + ", " +this.props.supervisors.supervisorCity+ ", " + this.props.supervisors.supervisorState + ", " + this.props.supervisors.supervisorZip}</label>
										</div>
									</div>
									<div className="singleRow borderItems">
										<div className="textStylingRegionDistrict">
											<div className="padItem">Phone Number:</div>
											<label className="infoRangerText">{this.props.supervisors.supervisorPhone}</label>
										</div>
									</div>
								</div> 
							: <div className="card">There is no Supervisor for this Region</div>
						}
					</div>
					<div>
						<div>
							<h1 className="pt-3 pb-3">District Special Ranger</h1>
						</div>
						{
							this.props.supervisors ? 
								<div className="card">
									<div className="singleRow borderItems">
										<div className="textStylingRegionDistrict">
											<div className="padItem">District:</div>
											<label className="infoRangerText">{this.props.supervisors.districtName }</label> 
										</div>
									</div>
									<div className="singleRow borderItems">
										<div className="textStylingRegionDistrict">
											<div className="padItem">Special Ranger Name: </div>
											<label className="infoRangerText">{this.props.supervisors.specialRangerFirstName + " " + this.props.supervisors.specialRangerLastName }</label>
										</div>
									</div>
									<div className="singleRow borderItems">
										<div className="textStylingRegionDistrict">
											<div className="padItem">Address: </div>
											<label className="infoRangerText">{this.props.supervisors.specialRangerAddress + ", " +this.props.supervisors.specialRangerCity+ ", " + this.props.supervisors.specialRangerState + ", " + this.props.supervisors.specialRangerZip}</label>
										</div>
									</div>
									<div className="singleRow borderItems">
										<div className="textStylingRegionDistrict">
											<div className="padItem">Phone Number:</div>
											<label className="infoRangerText">{this.props.supervisors.specialRangerPhone}</label>
										</div>
									</div>
								</div> 
							: <div className="card">There is no Special Ranger for this District</div>
						}
					</div>
					<div style={{ paddingTop: '25px'}}>
						<Button onClick={this.findYourRanger} size="lg" color="link">
							Find Your Ranger
							<i style={{ marginLeft: '5px' }} className="fas fa-external-link-alt"></i>
						</Button>
					</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		details: state.accountDetails.details,
		getting: state.accountDetails.getting,
		memberships: state.accountDetails.myMemberships,
		common: state.common,
		supervisors: state.common.supervisors,
		accountDetails: state.accountDetails
	};
}

export default withRouter(
	connect(mapStateToProps, {
		getAccountDetails,
		getMyMemberships,
		GetRegionAndDistrictSupervisor
	})(SpecialRanger)
);
